{
  "menu": {
    "home": "Início",
    "features": "Recursos",
    "pricing": "Preços",
    "about": "Sobre",
    "contact": "Contato",
    "blog": "Blog",
    "support": "Suporte",
    "dashboard": "Painel",
    "profile": "Perfil",
    "settings": "Configurações",
    "logout": "Sair",
    "login": "Entrar",
    "signup": "Cadastrar"
  },
  "footer": {
    "company": {
      "title": "Empresa",
      "about": "Sobre Nós",
      "careers": "Carreiras",
      "press": "Imprensa",
      "partners": "Parceiros"
    },
    "product": {
      "title": "Produto",
      "features": "Recursos",
      "pricing": "Preços",
      "security": "Segurança",
      "roadmap": "Roadmap"
    },
    "resources": {
      "title": "Recursos",
      "documentation": "Documentação",
      "tutorials": "Tutoriais",
      "blog": "Blog",
      "community": "Comunidade"
    },
    "legal": {
      "title": "Legal",
      "privacy": "Política de Privacidade",
      "terms": "Termos de Serviço",
      "cookies": "Política de Cookies",
      "compliance": "Conformidade"
    },
    "social": {
      "title": "Siga-nos",
      "twitter": "Twitter",
      "linkedin": "LinkedIn",
      "facebook": "Facebook",
      "youtube": "YouTube"
    },
    "copyright": "© 2024 Sigma08. Todos os direitos reservados."
  },
  "breadcrumb": {
    "home": "Início",
    "separator": "/"
  },
  "accessibility": {
    "skipToContent": "Pular para o conteúdo principal",
    "mainNavigation": "Navegação principal",
    "userMenu": "Menu do usuário",
    "languageSelector": "Seletor de idioma"
  }
}
